import { humanErrorText } from '../helpers/errorText';

// Старый формат: бэкенд отдаёт строку «Тип: текст\nStack…», берём текст
// между первым двоеточием и переводом строки.
const fromString = (text) => {
  const message = text.match(/:(.*)\n/);
  return message && message?.length ? message[1].trim() : null;
};

/**
 * Текст ошибки для тоста или null — тогда вызывающий показывает свой запасной
 * текст (`extractErrorMessage(err) || '…'`).
 *
 * api.onError отклоняет промис объектом ошибки axios, а не строкой, поэтому
 * сюда приходит что угодно: строка ответа, response.data объектом, сама ошибка
 * axios или обычный Error. Бросать здесь нельзя: упавший `.catch` оставляет
 * менеджера вообще без сообщения.
 */
const extractErrorMessage = (error) => {
  if (!error) return null;
  if (typeof error === 'string') return fromString(error);
  if (typeof error !== 'object') return null;

  // Ошибка axios несёт ответ бэкенда в response.data; если response нет —
  // это либо уже сам response.data, либо Error (сеть, таймаут, код).
  const payload = error.response ? error.response.data : error;
  // Тот же разбор, что и у тоста в api.onError: тексты совпадают, и
  // alert.error склеивает их в одно сообщение.
  return humanErrorText(payload);
};

export default extractErrorMessage;
